import { render, staticRenderFns } from "./Currency.vue?vue&type=template&id=09d9b672"
import script from "./Currency.vue?vue&type=script&lang=ts"
export * from "./Currency.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports